import { render, staticRenderFns } from "./VoiceAgentUpdated.vue?vue&type=template&id=5b4ce1ed"
import script from "./VoiceAgentUpdated.vue?vue&type=script&lang=js"
export * from "./VoiceAgentUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports